<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <b-button variant="primary" :to="{ name: 'propagate-create' }">
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }} </span>
        </b-button>
      </template>
    </app-breadcrumb>
    <div class="row d-flex justify-content-center">
      <div class="col-md-10">
        <div class="card">
          <div class="card-body">
            <validation-observer ref="propagateForm">
              <b-form @submit.prevent="" @reset.prevent="resetForm">
                <b-row>
                  <b-col cols="12">
                    <validation-provider #default="validationContext" name="Tiêu đề" vid="title" rules="required">
                      <b-form-group label="Tiêu đề">
                        <template #label>
                          <label class="d-block font-weight-bolder pb-0">Tiêu đề <span
                              class="text-danger">*</span></label>
                        </template>
                        <b-form-input v-model="frmData.title" autofocus :state="getValidationState(validationContext)"
                          placeholder="Tiêu đề" />
                        <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="5">
                    <validation-provider #default="validationContext" vid="is_type" name="Loại" rules="required">
                      <b-form-group>
                        <template #label>
                          <label class="d-block font-weight-bolder pb-0">Loại <span class="text-danger">*</span></label>
                        </template>
                        <v-select v-model="frmData.category_id" :options="dataType" label="name" :reduce="(val) => val.id"
                          placeholder="--Chọn--" :state="getValidationState(validationContext)" />
                        <b-form-invalid-feedback :state="getValidationState(validationContext)">
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Nội dung">
                      <template #label>
                        <label class="d-block font-weight-bolder pb-0">Nội dung</label>
                      </template>
                      <editor ref="tinymce" v-model="frmData.content" :init="tinyOptions" tinymce-script-src="" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group>
                      <!-- ATTACH ORIGINAL FILE -->
                      <upload-form :attached-files="frmData.attached_files"
                        @update-attached-files="onUpdateAttachedFiles" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12 mt-1">
                    <div class="flex align-items-center text-center">
                      <b-button type="button" class="mr-1" style="text-indent: -99999px;" variant="exit"
                        @click="onExit()">Thoát</b-button>
                      <b-button type="submit" variant="save" @click="validationForm(1)"> {{ $t('Save') }} </b-button>
                      <b-button type="submit" class="ml-1" variant="primary" @click="validationForm(5)"> {{ $t('Xuất bản')
                      }} </b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BRow, BCol, BForm, BFormInput, BFormInvalidFeedback,
  BFormGroup,
} from 'bootstrap-vue'
import {
  ref, reactive, computed, toRefs,
} from '@vue/composition-api'
import vSelect from 'vue-select'
import {
  required, email, alphaNum, min, max,
} from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'
import { showToast } from '@core/utils/utils';
import { getToken } from '@/auth/utils';
import {
  defaultOptions, apiUpload, apiDownload,
} from '@/libs/initTinymce'
import UploadForm from './UploadForm.vue'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
export default {
  components: {
    BCol,
    BRow,
    BButton,
    BFormGroup,
    BForm,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    UploadForm,
    Editor,
    AppBreadcrumb
  },
  data() {
    return {
      required, email, alphaNum, min, max,
    }
  },
  setup(props, context) {
    const accessToken = getToken();
    const attached_files = ref([])
    const custom_header = ref({
      Authorization: `Bearer ${accessToken}`,
    });
    const custom_data = ref({
      upload_status: 1,
    });

    const state = reactive({
      tinyOptions: null,
      api_upload: apiUpload,
      api_download: apiDownload,
    })

    state.tinyOptions = computed(() => {
      if (store.state.app.settings) {
        if (store.state.app.settings.news !== undefined && store.state.app.settings.news.editor_toolbar !== undefined) {
          const icons = store.state.app.settings.news.editor_toolbar.map(({ icon }) => icon);
          defaultOptions.toolbar = icons.join(' ');
        }
        if (store.state.app.settings.app !== undefined && store.state.app.settings.app.logo_mask !== undefined) {
          defaultOptions.images_mask_logo = store.state.app.settings.app.logo_mask;
        }
      }
      return defaultOptions
    });
    const blank = {
      title: '',
      category_id: '',
      attached_files: [],
      content: '',
      status: 0,
    }
    const dataType = ref([]);
    const frmData = ref(JSON.parse(JSON.stringify(blank)))
    store.dispatch('propagate/config').then(response => {
      const result = response.data;
      if (result.code == 200) {
        dataType.value = result.data
      }
    })

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)
    return {
      ...toRefs(state),
      refFormObserver,
      getValidationState,
      resetForm,
      frmData,
      dataType,
      custom_header,
      custom_data,
      attached_files,
    }
  },

  methods: {
    onUpdateAttachedFiles(attachedFiles) {
      this.frmData.attached_files = attachedFiles
    },
    onSubmit() {
      store.dispatch('propagate/create', this.frmData)
        .then(response => {
          const result = response.data;
          if (result.code === 200) {
            showToast(result.message, { variant: 'success' });
            this.$router.push({ name: 'propagate-list' });
          } else if (result.errors) {
            this.$refs.propagateForm.setErrors(result.errors);
          } else {
            showToast(result.message);
          }
        })
    },
    validationForm(status) {
      this.errorMessage = {}
      this.$refs.propagateForm.validate().then(success => {
        if (success) {
          this.frmData.status = status;
          this.onSubmit();
        }
      })
    },
    inputFile(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.uploadAttach.active) {
          this.$refs.uploadAttach.active = true
        }
      }
      if (newFile && newFile.error) {
        newFile.error = 'Tải lên thất bại'
      } else if (newFile && newFile.success && newFile.error == '') {
        if (newFile.response.code == 400) {
          newFile.error = 'Tải file thất bại'
        }
      }
      if (newFile && newFile.success) {
        if (newFile.response.code === 200) {
          newFile.file_id = newFile.response.data.id;
          newFile.full_path = newFile.response.data.full_path;
          newFile.extension = newFile.response.data.extension
          const result = newFile.response.data;
          const item = {
            id: result.id,
            extension: result.extension,
            size: newFile.size,
            uploaded: 1,
            file: result.file,
            name: result.name,
            uuid: result.uuid,
            mimetype: result.mimetype,
            full_path: result.full_path,
            type: result.type,
          }
          this.frmData.attached_files.push(item)
        }
      }
    },
    formatFileSize(bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals || 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
    getExtention(file) {
      const fileExt = file.name.split('.').pop().toLowerCase();
      let cssClass = '';
      if (['docx', 'doc'].includes(fileExt)) {
        cssClass = 'icon_docx'
      } else if (['pdf'].includes(fileExt)) {
        cssClass = 'icon_pdf'
      } else if (['csv', 'xlsx', 'xls'].includes(fileExt)) {
        cssClass = 'icon_xls'
      } else if (['mp4', 'webm'].includes(fileExt)) {
        cssClass = 'icon_clip'
      } else if (['mp3', 'wav'].includes(fileExt)) {
        cssClass = 'icon_music'
      } else {
        cssClass = 'icon_img'
      }
      return cssClass;
    },
    onDeleteAttach(file) {
      if (this.frmData.attached_files.length > 0) {
        const { file_id } = file;
        const attached_files = this.frmData.attached_files.filter((item) => item.id != file_id)
        this.$refs.uploadAttach.remove(file);
        this.frmData.attached_files = attached_files;
      }
    },
    onExit() {
      this.$router.push({ name: 'propagate-list' });
    },
  },

}
</script>

<style lang="scss">
.btnUpload {
  label {
    cursor: pointer;
  }
}

.attach_file {
  margin: 0;

  li {
    padding: 2px 0;
  }

  .trash {
    cursor: pointer;
  }
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>
